import cx from 'classnames';
import Image from 'next/image';
import NextLink from 'next/link';

import {Button, Text} from '#component/base';

import {MyTallyAgeCTACardProps} from './MyTallyAgeCTACard.types';

import * as css from './MyTallyAgeCTACard.css';

export const MyTallyAgeCTACard = ({
  href = '#',
  imageUrl,
  headline,
  lede,
  objectPosition,
  className,
  hasOverlay = true,
  textColor = 'white',
  variant = 'primary',
}: MyTallyAgeCTACardProps) => {
  return (
    <NextLink passHref href={href || '#'}>
      <a className={cx(css.MyTallyAgeCTACardRoot, className)}>
        {hasOverlay && (
          <div className={css.MyTallyAgeCTACardImageContainer}>
            {imageUrl && (
              <Image
                alt=""
                aria-hidden
                layout="fill"
                objectFit="cover"
                src={imageUrl}
                objectPosition={objectPosition}
                className={css.MyTallyAgeCTACardImage({variant: variant})}
              />
            )}
          </div>
        )}
        <div className={css.MyTallyAgeCTACardWrapperContent}>
          <div className={css.MyTallyAgeCTACardInnerWrapperContent}>
            <div className={css.MyTallyAgeCTACardInnerWrapperContentPrimary}>
              <Text
                as="h1"
                variant="heading2"
                color={textColor}
                className={css.MyTallyAgeCTACardInnerWrapperContentPrimaryText}>
                {headline}
              </Text>
              <Button
                className={css.MyTallyAgeCTACardMobileButton}
                aria-hidden
                as="span"
                icon="ArrowRight"
                variant="primary"
              />
            </div>
            <div className={css.MyTallyAgeCTACardInnerWrapperContentSecondary}>
              <Text
                as="p"
                className={css.MyTallyAgeCTACardInnerWrapperContentSecondaryText}
                color={textColor}>
                {lede}
              </Text>
              <Button
                className={css.MyTallyAgeCTACardButton}
                aria-hidden
                as="span"
                icon="ArrowRight"
                variant="primary"
              />
            </div>
          </div>
        </div>
      </a>
    </NextLink>
  );
};
